import type { IUserMilestone } from "@faire/web-api/indigofair/data/IUserMilestone";

export function buildIUserMilestone(
  partial: Partial<IUserMilestone>
): IUserMilestone {
  return partial as IUserMilestone;
}
